var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cadastro-simples-list',{attrs:{"endpoint":"intervencao-pedagogica","rota-base":"/admin/intervencao-pedagogica","titulo":"INTERVENÇÕES PEDAGÓGICAS","titulo-singular":"Intervenção Pedagógica","colunas-extras":[{"campo":"descricao","label":"Descrição","tipo":"text","span":24}]}})
}
var staticRenderFns = []

export { render, staticRenderFns }